import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from 'react-router-dom';
import { Button, Icon, IconButton } from '@mui/material';
import { useUpdateCategoryMutation } from 'App/services/categoryServiceApi';
import { BASE_URL } from 'baseConfig';
import { toast } from 'react-toastify';


export default function EditFormDialog({ category }) {
  const [open, setOpen] = useState(false);
  const [categoryName, setCategoryName] = useState(category.name);
  const [image, setImage] = useState(category.imagePath);
  const [imagePreview, setImagePreview] = useState(`${BASE_URL}${category.imagePath}`); 
  const navigate = useNavigate();

  const [updateCategory, { isLoading, isError }] = useUpdateCategoryMutation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleFileChange = (event) => {
    const file =event.target.files[0] 
    setImage(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleEditCategory = async (event) => {
    event.preventDefault();

    const formData = new FormData();

    if (image) {
      formData.append('imagePath', image);
    }
    // if(!categoryName){
    //   toast.error("Category name is required.");
    //   return
    // }

      formData.append('name', categoryName);
   
    try {
      
      await updateCategory({ id: category.id, values: formData });
      toast.success("Category Successfully updated!" )
      handleClose();
     
    } catch (error) {
      
      toast.error(error?.data?.error)
    }
  
   
  };

  return (
    <React.Fragment>
      <IconButton onClick={handleClickOpen}>
        <Icon>edit</Icon>
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: handleEditCategory,
        }}
      >
        <DialogTitle>Edit Category</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter the name of the category:
          </DialogContentText>
          <TextField
            autoFocus
            // required
            margin="dense"
            id="name"
            name="name"
            label="Category Name"
            type="text"
            fullWidth
            defaultValue={category.name}
            onChange={(e) => setCategoryName(e.target.value)}
          />
         
          <input
            type="file"
            accept="image/*"
            name='imagePath'
            // defaultValue={category.imagePath}
            onChange={handleFileChange}
            style={{ marginTop: '16px' }}
          />
           {imagePreview && (
            <div style={{ marginTop: '16px' }}>
              <img src={imagePreview} alt="Preview" style={{ maxWidth: '100%', maxHeight: '300px' }} />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" name="submit">Save</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
